import { widgetCopy } from '@/i18n/widget-copy'
import { h, render } from 'vue'
import { Leaf } from 'lucide-vue-next'
import type { AppLocale } from '@/i18n/messages'
import { defaultPipColors } from './pip-skins'
import loadingStyles from './pip-loading.css?inline'

/** Small, immediately available splash; never waits on the full HUD renderer. */
export function mountPipLoading(doc: Document, locale: AppLocale, dark: boolean): () => void {
  const colors = defaultPipColors(dark)
  const style = doc.createElement('style')
  style.dataset.pipLoadingStyle = ''
  style.textContent = loadingStyles
  const root = doc.createElement('main')
  root.className = 'pip-loading'
  root.dataset.theme = dark ? 'dark' : 'light'
  root.style.cssText = `--load-bg:${colors.bg};--load-surface:${colors.surface};--load-text:${colors.text};--load-muted:${colors.muted};--load-border:${colors.border};--load-accent:${colors.mesos};--load-soft:${colors.amberSoft};color-scheme:${dark ? 'dark' : 'light'}`
  root.innerHTML = `
    <div class="pip-loading-card">
      <header class="pip-loading-header" aria-hidden="true">
        <span class="pip-loading-brand">${widgetCopy(locale, 'Maple Log', '枫记')}<span>LIVE COMPANION</span></span>
        <span class="pip-loading-tag"><i></i>${widgetCopy(locale, 'Widget', '小组件')}</span>
      </header>
      <div class="pip-loading-main">
        <div class="pip-loading-emblem" aria-hidden="true">
          <svg class="pip-loading-orbit" viewBox="0 0 88 88" fill="none"><circle class="pip-loading-ring" cx="44" cy="44" r="40"/><circle class="pip-loading-arc" cx="44" cy="44" r="40"/></svg>
          <span class="pip-loading-mark"></span>
        </div>
        <div class="pip-loading-copy" role="status" aria-live="polite">
          <h1>${widgetCopy(locale, 'Loading widget…', '正在加载小组件…')}</h1>
        </div>
        <div class="pip-loading-track" aria-hidden="true"><span></span></div>
      </div>
      <footer class="pip-loading-footer">${widgetCopy(locale, 'Your panel will appear when ready', '准备完成后，数据面板将自动显示')}</footer>
    </div>`
  const mark = root.querySelector<HTMLElement>('.pip-loading-mark')!
  const fallback = doc.createElement('span')
  render(h(Leaf, { 'aria-hidden': 'true', strokeWidth: 1.6 }), fallback)
  mark.append(fallback)
  const logo = doc.createElement('img')
  logo.src = new URL('/favicon.png', window.location.href).href
  logo.alt = ''
  logo.addEventListener('load', () => { fallback.style.visibility = 'hidden' }, { once: true })
  logo.addEventListener('error', () => logo.remove(), { once: true })
  mark.append(logo)
  doc.title = widgetCopy(locale, 'Maple Log', '枫记')
  doc.documentElement.lang = locale
  doc.head.append(style)
  doc.body.append(root)
  return () => { render(null, fallback); root.remove(); style.remove() }
}
